import { render } from "./SiteDetail.vue?vue&type=template&id=7320edf0&scoped=true&ts=true"
import script from "./SiteDetail.vue?vue&type=script&lang=ts"
export * from "./SiteDetail.vue?vue&type=script&lang=ts"

import "./SiteDetail.vue?vue&type=style&index=0&id=7320edf0&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7320edf0"]])

export default __exports__